module.exports = __webpack_public_path__ + "static/media/analogyFourth.8d18f895.svg";